export class InvalidResourceIdError extends Error {
  constructor(str: string, issue?: string) {
    super(`Invalid resource ID "${str}" ${issue ?? ''}`);
  }
}
